/**
 * Skeleton helpers.
 *
 * Masking, not replacing. Each helper puts an element into a loading state
 * without changing the DOM around it, so when the data lands nothing moves.
 * That is the difference between a skeleton and a spinner-then-reflow, which
 * is what makes the page flicker.
 */

const SKELETON = 'is-skeleton';

/** Put one element into its loading state. `width` sizes text that is empty. */
export function maskOne(el, width) {
  if (!el) return;
  el.classList.add(SKELETON);
  if (width) el.setAttribute('data-w', width);
  el.setAttribute('aria-busy', 'true');
}

/** Take one element out of its loading state. */
export function unmaskOne(el) {
  if (!el) return;
  el.classList.remove(SKELETON);
  el.removeAttribute('data-w');
  el.removeAttribute('aria-busy');
}

/** Mask a set of ids at once. Pass `[id, width]` to size an empty one. */
export function mask(entries) {
  entries.forEach((entry) => {
    const [id, width] = Array.isArray(entry) ? entry : [entry, null];
    maskOne(document.getElementById(id), width);
  });
}

/** Unmask a set of ids. */
export function unmask(ids) {
  ids.forEach((id) => unmaskOne(document.getElementById(id)));
}

/** Clear every skeleton inside a root — a safety net after an error path. */
export function unmaskAll(root = document) {
  root.querySelectorAll('.' + SKELETON).forEach(unmaskOne);
}

/** Placeholder rows for a list that has not rendered yet. */
export function listSkeleton(rows = 3) {
  return `<div class="skel-rows" aria-busy="true" aria-label="Loading">${
    Array.from({ length: rows }, () => `
      <div class="skel-row">
        <span class="skel-row__num"></span>
        <span class="skel-row__body">
          <span class="skel-line" data-w="85"></span>
          <span class="skel-line" data-w="40"></span>
        </span>
      </div>`).join('')
  }</div>`;
}

/** A block that fills the slot it is dropped into (image previews). */
export function fillSkeleton() {
  return '<span class="skel-fill" aria-busy="true" aria-label="Loading"></span>';
}
